// extracted by mini-css-extract-plugin
module.exports = {"IndexPage":"IndexPage_IndexPage__24iF4","container":"IndexPage_container__rym-Z","products-wrap":"IndexPage_products-wrap__2NO3F"};